import Vue from 'vue'
/** 全局组件 */
function globalComponents(){
  const requireComponents = require.context('@/components/global', true, /\.vue/)
  // 遍历出每个组件的路径
  requireComponents.keys().forEach(fileName => {
      // 组件实例
      const reqCom = requireComponents(fileName)
      // 截取路径的文件名作为组件名
      const reqComName = fileName.substring(fileName.lastIndexOf('/') + 1).replace(".vue","")
      // 组件挂载
      Vue.component(reqComName, reqCom.default || reqCom)
  })
}
/** 通用js */
function commonJs(){
  //遍历store配置
  const requireCommonJs = require.context('./js', true, /\.js/)
  requireCommonJs.keys().forEach(fileName => {
    const commonJsModule = requireCommonJs(fileName)
    // 截取路径的文件名作为对象名
    const reqComName = fileName.substring(fileName.lastIndexOf('/') + 1).replace(".js", "")
    Vue.prototype[`$${reqComName}`] = commonJsModule .default || commonJsModule
  })
}
/** 将全局组件和通用js挂载到vue原型对象上 */
function mount (){
  globalComponents()
  commonJs()
}

export default {
  mount
}